var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "visitors" } }, [
    _c(
      "div",
      { staticClass: "visitors-sidebar", class: [_vm.dropdown && "closed"] },
      [
        _c("div", { staticClass: "top" }, [
          _c("div", { staticClass: "accordion" }, [
            _c("div", { staticClass: "head" }, [
              _c("div", { staticClass: "title" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("filter_alt"),
                ]),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("chatbotv2.FILTER")) +
                    "\n                    "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.filteredItems.length > 0
              ? _c(
                  "div",
                  { staticClass: "content" },
                  _vm._l(_vm.filteredItems, function (filter, index) {
                    return _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("MiniFilterPreview", {
                          attrs: { filter: filter },
                          on: {
                            deleteFilter: function ($event) {
                              return _vm.deleteFilter(index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "notting-here" }, [_c("NoData")], 1),
                ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bottom" }, [
          _c("div", { staticClass: "accordion" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("Filters", {
                  attrs: {
                    data: _vm.filters,
                    active: _vm.activeFilter,
                    defaultFilters: _vm.filteredItems,
                    align: "top",
                    "view-in-side": false,
                  },
                  on: {
                    changeActive: function (val) {
                      return (_vm.activeFilter = val)
                    },
                    filtered: function (items) {
                      return (_vm.filteredItems = items)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "classic-button" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("filter_alt"),
                            ]),
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.addFilter")) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "classic-button clear-filter",
                    on: { click: _vm.clearFilters },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                    _vm._v(
                      _vm._s(_vm.$t("message.clear")) + "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "visitors-content" }, [
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "material-icons",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  _vm.dropdown = !_vm.dropdown
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.dropdown ? "keyboard_double_arrow_right" : "close"
                  ) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tool-head" }, [
            _c(
              "div",
              { staticClass: "left-side" },
              [
                _c("a-input-search", {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: _vm.$t("message.typeSTToSearch") },
                  on: { search: _vm.onSearch, change: _vm.onSearch },
                  model: {
                    value: _vm.searchText,
                    callback: function ($$v) {
                      _vm.searchText = $$v
                    },
                    expression: "searchText",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right-side" },
              [
                _c("div", { staticStyle: { "margin-right": "3px" } }, [
                  _c("b", [_vm._v(_vm._s(_vm.page))]),
                  _vm._v("/"),
                  _c("b", [_vm._v(_vm._s(_vm.visitorsCount))]),
                  _vm._v(" of "),
                  _c("b", [_vm._v(_vm._s(_vm.visitorsTotal))]),
                  _vm._v(" Ziyaretçi\n                    "),
                ]),
                _vm._v(" "),
                _c(
                  "a-button-group",
                  { staticStyle: { "margin-right": "3px" } },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "flex-center-center",
                        on: { click: _vm.backwardPage },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("arrow_back_ios"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "flex-center-center",
                        on: { click: _vm.forwardPage },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("arrow_forward_ios"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-popover",
                  { attrs: { placement: "bottomRight", trigger: "click" } },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      _vm._l(_vm.allColumns, function (col) {
                        return _c(
                          "div",
                          [
                            _c(
                              "a-checkbox",
                              {
                                on: {
                                  change: function ($event) {
                                    return _vm.onChangeCol(col, $event)
                                  },
                                },
                                model: {
                                  value: col.enabled,
                                  callback: function ($$v) {
                                    _vm.$set(col, "enabled", $$v)
                                  },
                                  expression: "col.enabled",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(col.title) +
                                    "\n                                "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "flex-center-center",
                        staticStyle: { "margin-right": "3px" },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("app_registration"),
                        ]),
                      ]
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "flex-center-center",
                    on: { click: _vm.paddingReset },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v(
                        _vm._s(
                          _vm.paddingReseted ? "fullscreen" : "fullscreen_exit"
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-popover",
                  { attrs: { placement: "bottomRight", trigger: "click" } },
                  [
                    _c("template", { slot: "content" }, [
                      _c("div", { staticClass: "export-csv-visitor-page" }, [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("description"),
                        ]),
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("message.exportToCSV")) +
                            "\n                            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "flex-center-center",
                        staticStyle: { "margin-right": "3px" },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("more_horiz"),
                        ]),
                      ]
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("a-table", {
            class: [_vm.paddingReseted && "padding-zero"],
            attrs: {
              columns: _vm.columns,
              "data-source": _vm.visitors,
              pagination: false,
              customRow: function (record) {
                return {
                  on: {
                    click: function (event) {
                      return _vm.clickRow(record)
                    },
                  },
                }
              },
              scroll: { x: "calc(700px + 50%)" },
              "row-class-name": function () {
                return "limited-row"
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "visitingPage",
                  fn: function (text, record) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticStyle: {
                          "max-width": "100%",
                          overflow: "hidden",
                          height: "18px",
                          "white-space": "nowrap",
                          "text-transform": "ellipsis",
                          "text-overflow": "ellipsis",
                        },
                        attrs: { content: text },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(text) +
                            "\n                "
                        ),
                      ]
                    )
                  },
                },
                {
                  key: "tags",
                  fn: function (text, record) {
                    return _c(
                      "div",
                      {},
                      _vm._l(record.tags, function (tag) {
                        return _c(
                          "a-tag",
                          {
                            key: tag,
                            attrs: {
                              color: _vm.hashTags[tag]
                                ? _vm.hashTags[tag].color
                                : "orange",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.hashTags[tag]
                                    ? _vm.hashTags[tag].name
                                    : "Bilinmeyen"
                                ) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  },
                },
                _vm._l(_vm.visitorAttributes, function (cp) {
                  return {
                    key: "contactProperty_" + cp._id,
                    fn: function (text, record) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.getContactPropertyValue(record, cp._id))
                          ),
                        ]),
                      ]
                    },
                  }
                }),
                {
                  key: "firstSeen",
                  fn: function (text, record) {
                    return [_c("div", [_vm._v(_vm._s(_vm.formatDate(text)))])]
                  },
                },
                {
                  key: "lastSeen",
                  fn: function (text, record) {
                    return [_c("div", [_vm._v(_vm._s(_vm.formatDate(text)))])]
                  },
                },
                {
                  key: "connectionTime",
                  fn: function (text, record) {
                    return [_c("div", [_vm._v(_vm._s(_vm.formatDate(text)))])]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }